/**
 * @generated SignedSource<<36f1a7b44a627cac5a84e26ac266349b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingContent_viewer$data = {
  readonly account: {
    readonly __typename: "Account";
    readonly allowRecapDownload: boolean;
    readonly allowRecapEngagementStats: boolean;
    readonly id: string;
    readonly logo: string;
    readonly name: string;
  };
  readonly hasAccessToCopilot: boolean;
  readonly user: {
    readonly id: string;
  };
  readonly videoPlaybackSettings: {
    readonly " $fragmentSpreads": FragmentRefs<"TranscriptVideo_videoPlaybackSettings">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"HighlightsPanel_viewer" | "MeetingContainerModalNote_viewer" | "MeetingHeader_viewer" | "MeetingNote_viewer" | "MeetingPhaseContext_viewer" | "NoteHeader_viewer" | "PreMeetingControls_viewer" | "StatsPanel_viewer" | "TranscriptPanel_Transcript_viewer">;
  readonly " $fragmentType": "MeetingContent_viewer";
};
export type MeetingContent_viewer$key = {
  readonly " $data"?: MeetingContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingContent_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HighlightsPanel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingContainerModalNote_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingNote_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteHeader_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingPhaseContext_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_Transcript_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StatsPanel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingHeader_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreMeetingControls_viewer"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowRecapDownload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowRecapEngagementStats",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserVideoPlaybackSettings",
      "kind": "LinkedField",
      "name": "videoPlaybackSettings",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TranscriptVideo_videoPlaybackSettings"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "e86e0e7c7f030e72197c272f31d44aab";

export default node;
